<template>
  <div data-v-20e9a600="" class="filter-button-group mb-3">
    <div :class="{ 'active': numbersSelected }" @click="selectNumbers">{{ getLocalization('Phone numbers') }}</div>
    <div :class="['pin-mail-wrapper', { 'active': mailsSelected }]" @click="selectMails">{{
        getLocalization('E-mail\'s')
      }}
    </div>
  </div>
</template>

<script>
export default {
  name: "serviceSelectorTabs",
  props: {
    numbersSelected: {
      type: Boolean,
      required: true
    },
    mailsSelected: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    selectNumbers() {
      this.$emit('select-numbers');
    },
    selectMails() {
      this.$emit('select-mails');
    }
  }
}
</script>
<style scoped></style>
